import { render, staticRenderFns } from "./AddSubscrip.vue?vue&type=template&id=83604956&"
import script from "./AddSubscrip.vue?vue&type=script&lang=js&"
export * from "./AddSubscrip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports